<template>
  <div id="content-wrapper">
    <div class="container-fluid pb-0">
      <div class="top-mobile-search">
        <div class="row">
          <div class="col-md-12">
            <form class="mobile-search">
              <div class="input-group">
                <input type="text" placeholder="Search for..." class="form-control" />
                <div class="input-group-append">
                  <button type="button" class="btn btn-dark">
                    <i class="fas fa-search"></i>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div class="video-block section-padding">
        <div class="row">
          <div class="col-md-12">
            <div class="main-title">
              <!-- <div class="btn-group float-right right-action">
                <a class="right-action-link text-gray">See More</a>
              </div>-->
              <!-- TODO: 恢复See more -->
              <h6>Featured Video</h6>
            </div>
          </div>
          <div class="col-xl-3 col-sm-6 mb-3" v-for="video in featurevideos" v-bind:key="video.id">
            <videoinfocard
              :title_text="video.title"
              :video_id="video.id"
              :image_src="video.cover"
              :duration="video.duration"
              :views="video.views"
              :time_post="video.created_at"
              :category="video.category"
            ></videoinfocard>
            <!-- TODO: need further change on views -->
          </div>
        </div>
      </div>
      <hr class="mt-0" />
      <!-- Comedy -->
      <div class="video-block section-padding">
        <div class="row">
          <div class="col-md-12">
            <div class="main-title">
              <!-- <div class="btn-group float-right right-action">
                <a class="right-action-link text-gray">See More</a>
              </div>-->
              <h6>Popular Video</h6>
            </div>
          </div>
          <div class="col-xl-3 col-sm-6 mb-3" v-for="video in popularvideos" v-bind:key="video.id">
            <videoinfocard
              :title_text="video.title"
              :video_id="video.id"
              :image_src="video.cover"
              :duration="video.duration"
              :views="video.views"
              :time_post="video.created_at"
              :category="video.category"
            ></videoinfocard>
          </div>
        </div>
      </div>
      <hr class="mt-0" />

      <div class="video-block section-padding">
        <div class="row">
          <div class="col-md-12">
            <div class="main-title">
              <!-- <div class="btn-group float-right right-action">
                <a class="right-action-link text-gray">See More</a>
              </div>-->
              <h6>Recently-added</h6>
            </div>
          </div>
          <div class="col-xl-3 col-sm-6 mb-3" v-for="video in recentvideos" v-bind:key="video.id">
            <videoinfocard
              :title_text="video.title"
              :video_id="video.id"
              :image_src="video.cover"
              :duration="video.duration"
              :views="video.views"
              :time_post="video.created_at"
              :category="video.category"
            ></videoinfocard>
          </div>
        </div>
      </div>
      <hr class="mt-0" />
    </div>
  </div>
</template>


<script>
import videoinfocard from "../components/videoinfocard.vue";
import BasicAPIs from "../api/apis";
export default {
  name: "PgHome",
  components: {
    videoinfocard
  },
  props: {},
  data: function() {
    return {
      featurevideos: [],
      recentvideos: []
    };
  },
  created() {
    let vm = this;
    BasicAPIs.getFeatured(4).then(res => {
      if (res.data.success === true) {
        // console.log(res.data.data);
        vm.featurevideos = res.data.data.Items;
      } else {
        alert("api error getFeatured");
      }
    });

    BasicAPIs.getNewest(4).then(res => {
      if (res.data.success === true) {
        // console.log(res.data.data);
        vm.recentvideos = res.data.data.Items;
      } else {
        alert("api error getNewest");
      }
    });
  },
  computed: {
    popularvideos() {
      return this.featurevideos;
    }
  },
  mounted() {}
};
</script>


<style  lang='scss'>
</style>